import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../Store/api/auth/authSelectors';
import { URL_SEARCH_PARAMS } from '../../MPP-Common-SPA/common/constants/urlParams';

export const useProxyGuard = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const user = useSelector(selectCurrentUser);
    const currentStep = searchParams.get(URL_SEARCH_PARAMS.Step);
    const currentCode = searchParams.get(URL_SEARCH_PARAMS.Code);

    useEffect(() => {
        // Only apply guard for proxy users
        if (!user.isProxyUser) return;

        // Validate the application code in the URL matches the session's authorized application code.
        // This prevents proxy users from manipulating the URL to access restricted applications.
        // Also deny access if the proxy session is scoped to an application but the code param is missing.
        if (user.uniqueApplicationCode) {
            if (!currentCode) {
                console.warn(
                    `Proxy user session is scoped to application "${user.uniqueApplicationCode}" ` +
                    `but no application code was provided in the URL.`
                );
                navigate('/401', { replace: true });
                return;
            }
            const isUnauthorizedApplication = currentCode.toLowerCase() !== user.uniqueApplicationCode.toLowerCase();
            if (isUnauthorizedApplication) {
                console.warn(
                    `Proxy user attempted to access application "${currentCode}" ` +
                    `but session was created for "${user.uniqueApplicationCode}".`
                );
                navigate('/401', { replace: true });
                return;
            }
        }

        // Validate the step matches the authorized section
        if (currentStep) {
            const isEditingRestrictedSection = currentStep !== user.section;
            if (isEditingRestrictedSection) {
                console.warn(`Proxy user attempted to access page for which session was not created.`);
                navigate('/401', { replace: true });
            }
        }

    }, [currentStep, currentCode, user, navigate]);
};